<template>
    <div>
    <!-- Copyright -->
    <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <p class="p-small">Copyleft - 2020 Xavi Berna</a></p>
                </div>
            </div>
        </div>
    </div>
    <!-- end of copyright -->
    </div>
</template>

<script>
    export default {
        name: 'Peu',
        components: {
        }
    }
</script>